import { render, staticRenderFns } from "./EmployeeModal.vue?vue&type=template&id=54e98505&"
import script from "./EmployeeModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeModal.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports